import React, {useEffect} from "react";
import {createPortal} from "react-dom";
import {FaIcon} from "../FaIcon";
import {ClientProfileForm} from "./ClientProfileForm";
import {withTranslation} from 'react-i18next';
import './ClientProfileSidePanel.scss';

function ClientProfileSidePanelComponent({isOpen, clientId, clientName, onClose, t}) {
    useEffect(() => {
        if (!isOpen) return;
        const handleEscape = (e) => {
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', handleEscape);
        document.body.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = '';
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    const handleSuccess = () => {
        onClose();
    };

    const content = (
        <>
            <div
                className="client-profile-side-panel-overlay"
                onClick={onClose}
                role="button"
                tabIndex={-1}
                aria-label={t('client_profile.close')}
            />
            <div className="client-profile-side-panel" role="dialog" aria-labelledby="client-profile-panel-title">
                <header className="client-profile-side-panel-header">
                    <div className="client-profile-side-panel-header-content">
                        <h2 id="client-profile-panel-title" className="client-profile-side-panel-title">
                            {t('client_profile.panel_title')}
                        </h2>
                        {clientName && (
                            <p className="client-profile-side-panel-client-name">{clientName}</p>
                        )}
                    </div>
                    <button
                        type="button"
                        className="client-profile-side-panel-close"
                        onClick={onClose}
                        aria-label={t('client_profile.close')}
                    >
                        <FaIcon iconName="xmark" />
                    </button>
                </header>
                <div className="client-profile-side-panel-body">
                    <ClientProfileForm
                        clientId={clientId}
                        onSuccess={handleSuccess}
                        onCancel={onClose}
                        showCancelButton={true}
                    />
                </div>
            </div>
        </>
    );

    return createPortal(content, document.body);
}

export const ClientProfileSidePanel = withTranslation()(ClientProfileSidePanelComponent);
